import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {IClientsTileApi} from '../clients-tile.interface';
import {
  ColDef,
  ColGroupDef,
  GetRowIdFunc,
  GetRowIdParams,
  GridApi,
  GridOptions,
  GridReadyEvent,
} from 'ag-grid-community';
import {ICartControlObj} from './cart-control-obj.interface';
import {
  ConfirmIconButtonComponent
} from 'frontier/browserkit/src/lib/components/confirm-icon-button/confirm-icon-button.component';
import {AgGridModule} from 'ag-grid-angular';
import {DialogHeaderComponent} from 'frontier/browserkit/src/lib/components/dialog-header/dialog-header.component';
import {RowNode} from 'ag-grid-community/dist/lib/entities/rowNode';
import {AG_GRID_GERMAN_LOCALE} from "frontier";

interface Row {
  elsid: string;
  date: string;
  tariff: string;
  state: string;
  price: string;
  payer: string;
}

@Component({
  selector: 'app-cart-selection',
  templateUrl: './cart-selection.component.html',
  styleUrl: './cart-selection.component.scss',
  standalone: true,
  imports: [DialogHeaderComponent, MatDialogContent, AgGridModule, MatDialogActions, ConfirmIconButtonComponent],
})
export class CartSelectionComponent implements OnInit {
  rowData: any[] | null | undefined;
  colDefs: (ColGroupDef | ColDef)[] | null | undefined = [
    {field: 'select', headerName: '', headerCheckboxSelection: true, checkboxSelection: true},
    {
      field: 'elsid', headerName: 'ELSID'
    },
    {field: 'date', headerName: 'Datum'},
    {field: 'tariff', headerName: 'Tarif'},
    {field: 'price', headerName: 'Preis'},
    {field: 'payer', headerName: 'Kostenträger'},
    {field: 'state', headerName: 'Status'},
  ];
  gridOptions: GridOptions = {
    localeText: AG_GRID_GERMAN_LOCALE,
    rowHeight: 30,
    rowSelection: 'multiple',
    rowMultiSelectWithClick: true,
    onGridReady: (event: GridReadyEvent) => {
      event.api.sizeColumnsToFit();
      event.columnApi.autoSizeAllColumns();
    },
  };

  gridApi: GridApi;
  getRowId: GetRowIdFunc | undefined = ((row: GetRowIdParams) => row.data.signature);

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CartSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      carts: ICartControlObj[],
      client: IClientsTileApi,
      selectedCart: ICartControlObj,
    },
  ) {
  }

  ngOnInit(): void {
    this.rowData = this.data.carts.map((cart: ICartControlObj) => ({
      elsid: cart.number,
      date: cart.cartdate,
      payer: cart.payernamereadonly,
      price: cart.pricetotal,
      state: cart.statereadonly,
      tariff: cart.itemgroupidentifierreadonly,
      signature: cart.signature,
    } as Row));
    console.log(this.rowData);
  }

  onConfirm(): void {
    this.dialogRef.close(this.gridApi.getSelectedNodes().map((node: RowNode) => {
      return this.data.carts.find((cart: ICartControlObj): boolean => node.data.signature === cart.signature);
    }));
  }

  onGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    const node: RowNode = this.gridApi.getRowNode(this.data.selectedCart?.signature);
    if (node) {
      node.setSelected(true);
      this.gridApi.ensureNodeVisible(node);
    }
  }
}
